module.exports = __webpack_public_path__ + "img/zencal.2aab05ed.png";